import { applyMiddleware, compose, createStore } from "redux";
import { createLogicMiddleware, Logic } from "redux-logic";
import { routerMiddleware } from "connected-react-router";

import history from "utils/history";

import rootReducer, { IRootState } from "./reducer";
import logic from "./logic";

const logicMiddleware = createLogicMiddleware<IRootState>(logic as Logic[]);

const middleware = applyMiddleware(logicMiddleware, routerMiddleware(history));

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(rootReducer(history), composeEnhancers(
    middleware
));
